import React from 'react';
import { useSelector } from 'react-redux';
import { getUser } from 'selectors';
import { faBriefcase } from '@fortawesome/pro-regular-svg-icons';
import getText from 'context/language/getText';
import { urlConstructor, urlMap } from 'routes/urlMap';
import { featureEnabled } from 'utilities/featureFlag';
import {
  MANAGE_POSITIONS, MANAGE_SCHEDULES,
  POST_TO_RECURRING_SHIFTS,
} from 'constants/featureFlags';
import { NavGroup } from '../components';

export const ManagementLinks = () => {
  const user = useSelector(getUser);
  const showManagePositions = featureEnabled(MANAGE_POSITIONS);
  const showManageSchedules = featureEnabled(MANAGE_SCHEDULES);
  const showManageShifts = featureEnabled(POST_TO_RECURRING_SHIFTS) && !showManageSchedules;
  const links = [
    {
      url: urlConstructor(urlMap.MANAGE_JOBS),
      textPath: 'navbar.management.jobs',
      name: 'manage-jobs',
    },
    {
      url: urlConstructor(urlMap.POSITIONS),
      textPath: 'navbar.management.position',
      name: 'manage-positions',
      visible: showManagePositions,
    },
    {
      url: urlConstructor(urlMap.VENUES),
      textPath: 'navbar.management.location',
      name: 'manage-locations',
    },
    {
      url: urlConstructor(urlMap.WANDAS),
      textPath: 'navbar.settings.wandas',
      name: 'wandas',
    },
    {
      url: urlConstructor(urlMap.MANAGE_SHIFTS),
      textPath: 'navbar.management.schedule',
      name: 'manage-shifts',
      visible: showManageShifts,
    },
    {
      url: urlConstructor(urlMap.SCHEDULES),
      textPath: 'navbar.management.schedule',
      name: 'manage-schedules',
      visible: showManageSchedules,
    },
    {
      url: urlConstructor(urlMap.WONOLOERS),
      textPath: 'navbar.management.wonoloer',
      name: 'manage-wonoloers',
    },
    {
      url: urlConstructor(urlMap.TEAMS, { id: user.customer.id }),
      textPath: 'navbar.management.team',
      name: 'manage-teams',
    },
  ];
  return (
    <NavGroup
      links={links}
      icon={faBriefcase}
      label={getText('navbar.management.title')}
      name="manage"
    />
  );
};
